var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faChevronDown, faChevronUp } from "@fortawesome/pro-light-svg-icons";
import { useState } from "react";
import { Accordion } from "syf-component-library/ui/patterns";
import { Inline, Inset, Stack } from "syf-component-library/ui/spacing";
import { Body } from "syf-component-library/ui/typography";
import { AccordionBodyWrapper, AccordionHeaderWrapper, AccordionIcon, } from "./subcomponents";
import { colors } from "../../../theme";
export var TipAccordion = function (_a) {
    var id = _a.id, _b = _a.reason, description = _b.description, explanation = _b.explanation, resolution = _b.resolution;
    var _c = useState(false), isOpen = _c[0], setIsOpen = _c[1];
    return (_jsxs("div", { children: [_jsx(Accordion, { id: id, header: _jsx(Inset, __assign({ top: "small" }, { children: _jsxs(AccordionHeaderWrapper, { children: [_jsx(Body, __assign({ weight: "bold" }, { children: description })), _jsx(Inline, {}), _jsx(AccordionIcon, { color: colors.cyanBlue, size: "lg", icon: isOpen ? faChevronUp : faChevronDown })] }) })), body: _jsxs(AccordionBodyWrapper, { children: [explanation && _jsx(Body, { children: explanation }), explanation && resolution && _jsx(Stack, { size: "large" }), resolution && _jsx(Body, { children: resolution })] }), transitionDuration: 0.1, forceClose: false, forceRerenderBody: true, headerClickCallBack: function () {
                    setIsOpen(function (prev) { return !prev; });
                } }), _jsx(Stack, { size: "large" })] }));
};
